export default "__VITE_ASSET__DvT8Kogu__"